module.exports = __webpack_public_path__ + "static/media/arrow-down-white.a4f35136.svg";